import { Card, PageTitle } from "@repo/components";

const ShopByRoom = ({ data }) => {
  const { title, Card: ItemCard } = data;
  return (
    <section className="mx-auto px-4 py-10 md:max-w-screen-xl md:px-0">
      {title && <PageTitle title={title} variant="small" className="mb-5" />}
      <div className="grid grid-cols-2 gap-5 md:grid-cols-4">
        {ItemCard?.map((item) => (
          <Card key={item?.id} item={item} isOpaque={true} />
        ))}
      </div>
    </section>
  );
};

export default ShopByRoom;
